module.exports = __webpack_public_path__ + "static/img/1.f5a8a5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/1.jpg
// module id = 419
// module chunks = 1